import React from 'react';

export interface IconLinkProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconLink: React.FC<IconLinkProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M11.4698 6.69656L13.326 4.8404C13.7089 4.45707 14.1637 4.15295 14.6642 3.94541C15.1648 3.73787 15.7013 3.63099 16.2432 3.63086C16.785 3.63073 17.3216 3.73737 17.8223 3.94467C18.3229 4.15198 18.7778 4.45589 19.161 4.83904C19.5441 5.2222 19.848 5.67709 20.0553 6.17773C20.2626 6.67838 20.3693 7.21496 20.3691 7.75682C20.369 8.29868 20.2621 8.83521 20.0546 9.33576C19.8471 9.8363 19.5429 10.2911 19.1596 10.674L16.5079 13.3257C16.1249 13.7087 15.6702 14.0126 15.1697 14.2199C14.6692 14.4272 14.1328 14.5339 13.5911 14.5339C13.0494 14.5339 12.513 14.4272 12.0126 14.2199C11.5121 14.0126 11.0574 13.7087 10.6743 13.3257" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" /> <path d="M12.5302 17.3031L10.674 19.1593C10.2911 19.5426 9.8363 19.8467 9.33576 20.0543C8.83521 20.2618 8.29868 20.3687 7.75682 20.3688C7.21496 20.369 6.67838 20.2623 6.17773 20.055C5.67709 19.8477 5.2222 19.5438 4.83904 19.1606C4.45589 18.7775 4.15198 18.3226 3.94467 17.822C3.73737 17.3213 3.63073 16.7847 3.63086 16.2429C3.63099 15.701 3.73787 15.1645 3.94541 14.6639C4.15295 14.1634 4.45707 13.7086 4.8404 13.3257L7.49205 10.674C7.87509 10.291 8.32983 9.98712 8.8303 9.77982C9.33077 9.57252 9.86717 9.46582 10.4089 9.46582C10.9506 9.46582 11.487 9.57252 11.9874 9.77982C12.4879 9.98712 12.9426 10.291 13.3257 10.674" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" />  
    </svg>
  );
};

export default IconLink;
